import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { Button, Form, Spin, Input } from "antd";
import { useNavigate } from "react-router-dom";
import { openNotification } from "../../../shared/notification";
import { get, put } from "../../../services";
import { useParams } from "react-router-dom";
import ReactQuill from "react-quill";
import { ReactQuillOptions } from "../../../utils/react-quill-options";

const AddBlogs = () => {
  const [form] = Form.useForm();
  const { id } = useParams();
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [information, setInformation] = useState({});
  const [getLoader, setGetLoader] = useState(true);

  // GET SINGLE
  useEffect(() => {
    get(`/seoTags/${id}`)
      .then((response) => {
        setInformation(response?.data);
        console.log(response?.data);
        setGetLoader(false);
      })
      .catch((error) => {
        setLoader(false);
      });
    // eslint-disable-next-line
  }, []);

  // Submit Handler
  const onFinish = async (values) => {
    setLoader(true);
    put(`/seoTags/${id}`, values)
      .then(() => {
        openNotification("Success", "SEO updated successfully");
        setLoader(false);
        navigate("/seo");
        form.resetFields();
      })
      .catch((error) => {
        setLoader(false);
        openNotification("Error", error?.response?.data?.message);
      });
  };

  return (
    <React.Fragment>
      <Helmet>
        <title>Edit SEO</title>
        <meta name="description" content="Add and manage properties" />
      </Helmet>
      {/* Header */}
      <div className="header">
        <h3>Edit SEO</h3>
      </div>
      {getLoader ? (
        <div className="spin_information">
          <Spin />
        </div>
      ) : (
        <div className="form_container">
          <Form
            form={form}
            layout="vertical"
            onFinish={onFinish}
            initialValues={{
              // Basic
              title: information?.title,
              meta_title: information?.meta_title,
              meta_keywords: information?.meta_keywords,
              meta_description: information?.meta_description,
            }}
          >
            <div>
              {/*  Title*/}
              <Form.Item
                name="title"
                label="Page Title"
                rules={[{ required: false, message: "This field is required" }]}
              >
                <Input />
              </Form.Item>
              {/* Meta Title*/}
              <Form.Item
                name="meta_title"
                label="Meta Title"
                rules={[{ required: false, message: "This field is required" }]}
              >
                <Input />
              </Form.Item>
              {/* meta_keywords */}
              <Form.Item
                name="meta_keywords"
                label="Meta Keywords"
                rules={[{ required: false, message: "This field is required" }]}
              >
                <Input />
              </Form.Item>
              {/* description */}
              <Form.Item
                name="meta_description"
                label="Meta Description"
                rules={[
                  { required: false, message: "Description is required" },
                ]}
              >
                <ReactQuill theme="snow" modules={ReactQuillOptions} />
              </Form.Item>
            </div>
            {/* Footer Buttons */}
            <Form.Item>
              <div className="form_submit pt-15">
                <Button
                  className="back_button"
                  onClick={() => {
                    navigate("/seo");
                  }}
                >
                  Back
                </Button>

                <Button htmlType="submit" type="primary">
                  {loader ? "Please Wait..." : "Save"}
                </Button>
              </div>
            </Form.Item>
          </Form>
        </div>
      )}
    </React.Fragment>
  );
};

export default AddBlogs;
